module.exports = __webpack_public_path__ + "static/media/instructivosc2.6d17e0d3.png";